export const SEGMENT_DEPART = 1
export const SEGMENT_RETURN = 2

export const SEGMENT_PICKUP = "pickup"
export const SEGMENT_PAYMENT = "payment"
